export function getCurrentDimension(){
    return {
        width: window.innerWidth,
        height: window.innerHeight
    }
  }